// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
// @ts-expect-error
import withDeprecationWarning from '@bubble-ui/hoc-with-deprecation-warning';
var ActionIconRotatePath = 'M2.686 7a3.22 3.22 0 0 1-.13-.63V6a3.39 3.39 0 0 1 3-3.36h.34c.635 0 1.257.184 1.79.53L6.246 5h5.67l-1.74-5-1.26 1.57a5.179 5.179 0 0 0-3.03-.95A5.38 5.38 0 1 0 11.166 7h-2a3.39 3.39 0 0 1-3.25 2.38A3.39 3.39 0 0 1 2.686 7Z';
var ActionIconRotate = withDeprecationWarning({
  name: 'ActionIconRotate',
  removalDate: 'v6.0.0',
  useInstead: 'ActionIconRefresh'
})(baseIcon('ActionIconRotate', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconRotatePath
}));
ActionIconRotate.displayName = 'ActionIconRotate';

/**
 * @deprecated this component is outdated and will be removed with v6.0.0. Use ActionIconRefresh isntead.
 */
export default ActionIconRotate;
//# sourceMappingURL=index.js.map